<template>
  <Slideout :id="slideoutId" class="nav-slideout" @close-slideout="handleCloseSlideout">
    <div class="nav-slideout-container">
      <slot></slot>
      <button aria-label="close slideout" class="nav-slideout-close" @click="toggleSlideout">
        <span class="close-normal close-large"></span>
      </button>
    </div>
  </Slideout>
</template>

<script setup>
import { useDebounceFn } from '@vueuse/core';
import Slideout from '@nuxt-common/atomic-ui/app/components/slideout/Slideout';

const props = defineProps({
  slideoutId: {
    type: String,
    required: true,
  },
  provider: {
    type: Function,
    required: true,
  },
});

const emit = defineEmits(['close-slideout']);
const { init, toggleSlideout } = props.provider();
const handleCloseSlideout = useDebounceFn(() => {
  emit('close-slideout');
}, 300);

if (init) {
  init(props.slideoutId);
}
</script>

<style lang="scss">
@import '~/assets/scss/mixins';

.nav-slideout {
  div.slideout {
    padding: 0;

    div.slideout-body {
      padding: 0;
    }
  }

  header.slideout-header {
    display: none;
  }

  @include breakpoint(small down) {
    .slideout {
      width: 100% !important;
    }
  }

  &-close {
    display: flex;
    position: absolute;
    right: 48px;
    top: 48px;
    cursor: pointer;
    background-color: #fff;

    @include breakpoint(medium down) {
      right: 20px;
      top: 32px;
    }
  }

  &-container {
    padding: 0 48px;
    position: relative;

    @include breakpoint(medium down) {
      padding: 0 20px;
    }
  }
}
</style>
